import http from '@/utils/http';

/**
 * 获取分页查询全量仓库-cyj
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/asset/transfer/warehouse/pageList',
        method: 'post',
        data
    });
};

/**
 * 全量仓库-批量保存/修改承接人-cyj
 */
export function batchUpdateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/warehouse/batchUpsert',
        method: 'post',
        data
    });
};

/**
 * 全量仓库-修改承接人-cyj
 */
export function updateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/warehouse/update',
        method: 'post',
        data
    });
};

/**
 * 导入-cyj
 */
export function importAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/warehouse/importWarehouse',
        method: 'post',
        data
    });
};
